import script from "./FandQues.vue?vue&type=script&setup=true&lang=js"
export * from "./FandQues.vue?vue&type=script&setup=true&lang=js"

import "./FandQues.vue?vue&type=style&index=0&id=536ce184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536ce184"]])

export default __exports__